import { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { clientDateFormat } from '../../../../entities/Trip';

import { instance as axios } from '../../../../api/axios';
import { SecurityUnloadingReport } from './interfaces';

export class SecurityUnloadingReportService {
  public static async getReports(startDate: string, endDate: string, branchId: string) {
    try {
      const url = '/Reports/unloading';
      const response: AxiosResponse<SecurityUnloadingReport[]> = await axios.get(url, {
        params: {
          SDate: startDate,
          EDate: endDate,
          branchId,
        },
      });

      return response.data.reverse();
    } catch (error: any) {
      throw error.response;
    }
  }

  public static formatReportForTable(reports: SecurityUnloadingReport[]): SecurityUnloadingReport[] {
    return reports.map((report) => ({
      ...report,
      departureDateTime: format(new Date(report.departureDateTime || ''), clientDateFormat),
      entryDateTime: format(new Date(report.entryDateTime || ''), clientDateFormat),
    }));
  }
}
